module.exports = __webpack_public_path__ + "media/images/defs-02749d6f529a7ce03c4e458719ca5ac4.svg";